import { Agencies } from "./../models/agencies";
import { AgenciesService } from "./../services/agencies/agencies.service";
import { AwscontrolService } from "./../services/aws/awscontrol.service";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgForm } from "@angular/forms";
import * as _ from "lodash";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';

import { AGENCES_SERVICES } from "./../classesTs/agences-services";
import { MATERIAUX } from "./../classesTs/Materiax";
import { VILLES } from "./../classesTs/Ville";

interface Role {
    value: string;
    viewValue: string;
}

@Component({
    selector: "app-ajouter-agencie",
    templateUrl: "./ajouter-agencie.component.html",
    styleUrls: ["./ajouter-agencie.component.scss"],
})
export class AjouterAgencieComponent implements OnInit {
    @ViewChild("agencyForm", { static: false })
    agencyForm!: NgForm;

    @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;
    @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;

    public agence: any;
    siteFormControl = new FormControl('');
    selectedFiles1!: FileList;
    fileNames: any[] = [];
    photourl!: string;
    allAttch: any[] = [];
    public image: string | null = null;
    public totalFiles = 0;
    public uploadedImages: string[] = [];

    agencieData: any = {};
    dataSource = new MatTableDataSource();
    displayedColumns: string[] = [];
    @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

    isEditMode = false;
    isLoading = false;
    currentStep = 1;
    isUploading = false;

    // ✅ Aperçu du sous-domaine
    subdomainPreview: string = '';

    roles: Role[] = [
        { value: "promoteur-immobilieres", viewValue: "Promoteur Immobilier" },
        { value: "materiaux-construction", viewValue: "Matériaux de Construction" },
        { value: "agence-immobilieres", viewValue: "Agence Immobilière" },
        { value: "agence-service", viewValue: "Agence de Service" },
        { value: "meilleurs-biens", viewValue: "Meilleurs Biens" },
        { value: "cafe-restaurant", viewValue: "Café-Restaurant" },
    ];

    regions: { value: string; viewValue: string }[] = VILLES.map(ville => ({
        value: ville.id,
        viewValue: ville.label
    }));

    constructions: { value: string; viewValue: string }[] = MATERIAUX.map(materiel => ({
        value: materiel.value,
        viewValue: materiel.label
    }));

    CategorieServices: { value: string; viewValue: string }[] = AGENCES_SERVICES.map(service => ({
        value: service.value,
        viewValue: service.label
    }));

    sousCategorieServices: { value: string; viewValue: string }[] = [
        { value: "leasing", viewValue: "Leasing" },
        { value: "SocIndustriel", viewValue: "Sociétés Industrielles" },
        { value: "servicesDivers", viewValue: "Services Divers" }
    ];

    constructor(
        private location: Location,
        private agenciesService: AgenciesService,
        private awsService: AwscontrolService,
        private router: Router
    ) {
        this.agencieData = {};
    }

    ngOnInit(): void {
        this.initializeForm();
        this.agenciesService.refreshNeeded.subscribe(() => this.getData());
        this.getData();
        this.checkAwsConnection();
    }

    checkAwsConnection(): void {
        this.awsService.checkHealth().subscribe({
            next: (response) => {
                console.log('✅ AWS S3 Connection Healthy:', response);
            },
            error: (err) => {
                console.warn('⚠️ AWS S3 Connection Warning:', err);
            }
        });
    }

    initializeForm(): void {
        this.agencieData = {
            id: 0,
            name: '',
            email: '',
            description: '',
            region: '',
            role: '',
            adresse: '',
            categorie: '',
            sous_categorie: '',
            website_url: '',
            facebook_url: '',
            instagram_url: '',
            linkedin_url: '',
            twitter_url: '',
            tiktok_url: '',
            phone_number: '',
            phone_number2: '',
            phone_number_commercial: '',
            videoUrl: '',
            videoUrl2: '',
            logo_url: '',
            coffee: 'no',
            enableFacebookShare: true,
            enableWhatsAppShare: true,
            enableMessengerShare: true,
            defaultShareMessage: '',
            agencyPublicUrl: '',
            mobile_apps: [],
            publicShareMessage: '',
            subdomain: ''   // ✅ Nouveau champ
        };
        this.subdomainPreview = '';
    }

    getData(): void {
        if (this.paginator) {
            this.dataSource.paginator = this.paginator;
        }
        this.getAllAgencies();
    }

    getAllAgencies(): void {
        this.agenciesService.getList().subscribe((response: any) => {
            this.dataSource.data = response;
        });
    }

    editItem(element: any): void {
        this.agencieData = _.cloneDeep(element);
        this.isEditMode = true;
        if (this.agencieData.logo_url) {
            this.image = this.agencieData.logo_url;
            this.uploadedImages = [this.agencieData.logo_url];
        }
        this.subdomainPreview = this.getSubdomainPreview();
    }

    cancelEdit(): void {
        this.isEditMode = false;
        this.resetForm();
    }

    resetForm(): void {
        if (this.agencyForm) {
            this.agencyForm.resetForm();
        }
        this.initializeForm();
        this.uploadedImages = [];
        this.image = null;
        this.isEditMode = false;
        this.currentStep = 1;
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
        this.subdomainPreview = '';
    }

    getSubdomainPreview(): string {
        if (this.agencieData.subdomain && this.agencieData.subdomain.trim()) {
            return `https://${this.agencieData.subdomain.trim().toLowerCase()}.tunimmob.com`;
        }
        return '';
    }

    onSubdomainChange(): void {
        this.subdomainPreview = this.getSubdomainPreview();
    }

    onRoleChange(): void {
        this.agencieData.categorie = '';
        this.agencieData.sous_categorie = '';
        this.agencieData.coffee = 'no';
    }

    onCategorieChange(): void {
        if (this.agencieData.categorie !== 'servicesDivers') {
            this.agencieData.sous_categorie = '';
        }
    }

    showCategoryField(): boolean {
        return ['materiaux-construction', 'agence-service'].includes(this.agencieData.role);
    }

    showSousCategorieField(): boolean {
        return this.agencieData.role === 'agence-service' && 
               this.agencieData.categorie === 'servicesDivers';
    }

    getRoleIcon(role: string): string {
        const icons: { [key: string]: string } = {
            'promoteur-immobilieres': 'real_estate_agent',
            'materiaux-construction': 'construction',
            'agence-immobilieres': 'home_work',
            'agence-service': 'business_center',
            'meilleurs-biens': 'star',
            'cafe-restaurant': 'restaurant'
        };
        return icons[role] || 'business';
    }

    getFormProgress(): number {
        let filled = 0;
        const totalFields = 8;
        if (this.agencieData.name && this.agencieData.name.trim() !== '') filled++;
        if (this.agencieData.email && this.agencieData.email.trim() !== '') filled++;
        if (this.agencieData.role && this.agencieData.role.trim() !== '') filled++;
        if (this.agencieData.region && this.agencieData.region.trim() !== '') filled++;
        if (this.agencieData.description && this.agencieData.description.trim() !== '') filled++;
        if (this.agencieData.adresse && this.agencieData.adresse.trim() !== '') filled++;
        if (this.agencieData.phone_number && this.agencieData.phone_number.trim() !== '') filled++;
        if (this.image) filled++;
        return Math.round((filled / totalFields) * 100);
    }

    goToStep(step: number): void {
        this.currentStep = step;
        const section = document.querySelector(`[data-step="${step}"]`);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    isStepValid(step: number): boolean {
        return true;
    }

    getRandomString(length: number): string {
        const randomChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < length; i++) {
            result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
        }
        return result;
    }

    uploadimg2(): void {
        if (!this.selectedFiles1 || this.selectedFiles1.length === 0) {
            Swal.fire({ icon: "warning", title: "Attention", text: "Aucun fichier sélectionné.", timer: 3000, showConfirmButton: false });
            return;
        }
        if (this.selectedFiles1.length > 5) {
            Swal.fire({ icon: "warning", title: "Trop de fichiers", text: "Maximum 5 fichiers.", timer: 3000, showConfirmButton: false });
            return;
        }
        for (let i = 0; i < this.selectedFiles1.length; i++) {
            const file = this.selectedFiles1[i];
            if (file.size > 2 * 1024 * 1024) {
                Swal.fire({ icon: "error", title: "Fichier trop volumineux", text: `${file.name} > 2MB`, timer: 3000, showConfirmButton: false });
                continue;
            }
            if (!file.type.match(/image\/(jpeg|png|jpg|gif|webp)/)) {
                Swal.fire({ icon: "error", title: "Format non supporté", text: `${file.name} : JPEG, PNG, JPG, GIF, WEBP uniquement`, timer: 3000, showConfirmButton: false });
                continue;
            }
            this.uploadFileimg2(file);
        }
    }

    uploadFileimg2(file: File): void {
        this.isUploading = true;
        this.isLoading = true;
        this.awsService.uploadFile(file, 'logos').subscribe({
            next: (response) => {
                this.isUploading = false;
                this.isLoading = false;
                if (response.success && response.urls && response.urls.length > 0) {
                    const uploadedUrl = response.urls[0];
                    console.log('✅ Image uploaded:', uploadedUrl);
                    this.uploadedImages.push(uploadedUrl);
                    this.image = this.uploadedImages[0];
                    Swal.fire({ icon: "success", title: "Upload réussi!", text: `${file.name} uploadé`, timer: 2000, showConfirmButton: false });
                } else {
                    throw new Error(response.error || 'Upload failed');
                }
            },
            error: (err) => {
                this.isUploading = false;
                this.isLoading = false;
                console.error("❌ Erreur upload:", err);
                Swal.fire({ icon: "error", title: "Échec de l'upload", text: `Impossible d'uploader ${file.name}: ${err.message}` });
            }
        });
    }

    selectFileimg2(e: Event): void {
        const input = e.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.selectedFiles1 = input.files;
            this.uploadimg2();
        }
    }

    removeImage(index?: number): void {
        if (index !== undefined && this.uploadedImages.length > index) {
            const imageUrl = this.uploadedImages[index];
            this.deleteImageFromS3(imageUrl, index);
        } else {
            this.uploadedImages.forEach((url, idx) => {
                this.deleteImageFromS3(url, idx);
            });
        }
    }

    private deleteImageFromS3(imageUrl: string, index: number): void {
        Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Cette image sera définitivement supprimée!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.awsService.deleteFile(imageUrl).subscribe({
                    next: (response) => {
                        this.isLoading = false;
                        this.uploadedImages.splice(index, 1);
                        if (this.uploadedImages.length > 0) {
                            this.image = this.uploadedImages[0];
                        } else {
                            this.image = null;
                        }
                        if (this.fileInput) {
                            this.fileInput.nativeElement.value = '';
                        }
                        Swal.fire({ icon: "success", title: "Supprimé!", text: response.message || "Image supprimée", timer: 2000, showConfirmButton: false });
                    },
                    error: (err) => {
                        this.isLoading = false;
                        console.error('❌ Erreur suppression:', err);
                        Swal.fire({ icon: "error", title: "Échec de la suppression", text: "Impossible de supprimer l'image." });
                    }
                });
            }
        });
    }

    formatText(command: string): void {
        if (this.descriptionTextarea) {
            const textarea = this.descriptionTextarea.nativeElement;
            const start = textarea.selectionStart;
            const end = textarea.selectionEnd;
            const selectedText = this.agencieData.description.substring(start, end);
            if (!selectedText) return;
            let formattedText = '';
            let tag = '';
            switch (command) {
                case 'bold': tag = 'strong'; break;
                case 'italic': tag = 'em'; break;
                case 'underline': tag = 'u'; break;
            }
            formattedText = `<${tag}>${selectedText}</${tag}>`;
            const newText = this.agencieData.description.substring(0, start) + formattedText + this.agencieData.description.substring(end);
            this.agencieData.description = newText;
            setTimeout(() => {
                textarea.focus();
                const newPosition = start + formattedText.length;
                textarea.setSelectionRange(newPosition, newPosition);
            }, 0);
        }
    }

    onSubmit(): void {
        if (!this.agencieData.name || this.agencieData.name.trim() === '') {
            Swal.fire({ icon: "warning", title: "Champ requis", text: "Le nom est obligatoire." });
            return;
        }
        if (!this.agencieData.email || this.agencieData.email.trim() === '') {
            Swal.fire({ icon: "warning", title: "Champ requis", text: "L'email est obligatoire." });
            return;
        }
        if (!this.agencieData.role || this.agencieData.role.trim() === '') {
            Swal.fire({ icon: "warning", title: "Champ requis", text: "Le type de société est obligatoire." });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.agencieData.email)) {
            Swal.fire({ icon: "error", title: "Email invalide", text: "Veuillez entrer une adresse email valide." });
            return;
        }

        this.isLoading = true;

        const agencyData: any = {
            name: this.agencieData.name.toUpperCase().trim(),
            email: this.agencieData.email.toLowerCase().trim(),
            role: this.agencieData.role,
            description: this.agencieData.description?.trim() || '',
            region: this.agencieData.region || '',
            adresse: this.agencieData.adresse?.trim() || '',
            phone_number: this.agencieData.phone_number || null,
            phone_number2: this.agencieData.phone_number2 || null,
            phone_number_commercial: this.agencieData.phone_number_commercial || null,
            logo_url: this.image || '',
            subdomain: this.agencieData.subdomain?.trim()?.toLowerCase() || null,
        };

        if (this.agencieData.role === 'materiaux-construction' || 
            this.agencieData.role === 'agence-service' ||
            this.agencieData.role === 'meilleurs-biens' ||
            this.agencieData.role === 'agence-immobilieres') {
            agencyData.categorie = this.agencieData.categorie || '';
            agencyData.sous_categorie = this.agencieData.sous_categorie || '';
        }

        if (this.agencieData.website_url?.trim()) agencyData.website_url = this.agencieData.website_url.trim();
        if (this.agencieData.facebook_url?.trim()) agencyData.facebook_url = this.agencieData.facebook_url.trim();
        if (this.agencieData.instagram_url?.trim()) agencyData.instagram_url = this.agencieData.instagram_url.trim();
        if (this.agencieData.linkedin_url?.trim()) agencyData.linkedin_url = this.agencieData.linkedin_url.trim();
        if (this.agencieData.twitter_url?.trim()) agencyData.twitter_url = this.agencieData.twitter_url.trim();
        if (this.agencieData.tiktok_url?.trim()) agencyData.tiktok_url = this.agencieData.tiktok_url.trim();
        if (this.agencieData.videoUrl?.trim()) agencyData.videoUrl = this.agencieData.videoUrl.trim();
        if (this.agencieData.videoUrl2?.trim()) agencyData.videoUrl2 = this.agencieData.videoUrl2.trim();

        console.log('Submitting agency data:', agencyData);

        this.agenciesService.createItem(agencyData).subscribe(
            (response: any) => {
                this.isLoading = false;
                let message = 'Société ajoutée avec succès!';
                if (typeof response === 'string') message = response;
                else if (response && response.message) message = response.message;

                Swal.fire({
                    icon: "success",
                    title: "Succès!",
                    text: message,
                    showConfirmButton: true,
                    confirmButtonColor: '#4caf50',
                    timer: 3000
                }).then(() => {
                    this.resetForm();
                    this.location.back();
                });
            },
            (error: HttpErrorResponse) => {
                this.isLoading = false;
                console.error('Full error object:', error);
                let errorMessage = "Une erreur est survenue lors de l'ajout de la société.";
                let errorTitle = "Erreur";

                if (error.status === 403) {
                    errorTitle = "Accès refusé";
                    errorMessage = "Vous n'avez pas les permissions nécessaires.";
                } else if (error.status === 401) {
                    errorTitle = "Non authentifié";
                    errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
                } else if (error.error) {
                    if (typeof error.error === 'string') errorMessage = error.error;
                    else if (error.error.message) {
                        errorMessage = error.error.message;
                        if (error.error.message.includes("User exist")) {
                            errorTitle = "Email déjà utilisé";
                            errorMessage = "Un utilisateur avec cet email existe déjà.";
                        }
                    }
                } else if (error.status === 0) {
                    errorMessage = "Impossible de se connecter au serveur.";
                } else if (error.status === 500) {
                    errorMessage = "Erreur interne du serveur. Veuillez réessayer plus tard.";
                }

                Swal.fire({
                    icon: "error",
                    title: errorTitle,
                    html: `<p>${errorMessage}</p><small>Code: ${error.status}</small>`,
                    confirmButtonColor: '#f44336'
                });
            }
        );
    }

    onInputChange(): void {
        if (this.agencieData.name) {
            this.agencieData.name = this.agencieData.name
                .replace(/[^A-Z0-9\s]/gi, '')
                .toUpperCase();
        }
    }

    getCurrentStepName(): string {
        switch(this.currentStep) {
            case 1: return 'Informations de Base';
            case 2: return 'Coordonnées';
            case 3: return 'Liens & Réseaux';
            case 4: return 'Logo';
            default: return 'Formulaire';
        }
    }

    canSubmit(): boolean {
        return !!(this.agencieData.name && this.agencieData.email && this.agencieData.role);
    }

    getFileNameFromUrl(url: string): string {
        const urlParts = url.split('/');
        return urlParts[urlParts.length - 1];
    }

    getImagePreview(): string {
        return this.image || 'assets/images/default-logo.png';
    }

    isAwsServiceAvailable(): boolean {
        return !!this.awsService;
    }
}